import React from 'react';
import ReactDOM from 'react-dom';
import './css/home.css';
import './css/me.css';
import './css/mybeats.css';
import './css/addbeats.css';
import './css/join.css';
import './css/search.css';
import './css/settings.css';
import './css/help.css';
import './css/music.css';
import './css/playhouse.css';
import './css/tomusic.css';
import './css/Chat.css';
import './css/index.css';
import './css/mediaquerry.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
